import React  from 'react';
const PopupAgreement = (props) =>{
  let buildingInfo = props.buildingInfo && props.buildingInfo && props.buildingInfo.data? props.buildingInfo.data : {}
  //console.log("buildingInfo:data4",buildingInfo,props)

  let name_app = buildingInfo.loginAlphaboxFlag?"Alpha Box":"SmartZone™"
  return <div className="privacy-policy-ui">
    {/* {props.locale} */}
    <h3> { props.locale === 'TH'?'นโยบายคุ้มครองข้อมูลส่วนบุคคล':'Privacy Policy'} </h3>
   {
     props.locale === 'TH'?<>
     <div>
     นโยบายคุ้มครองข้อมูลส่วนบุคคลนี้จัดทำขึ้นเพื่ออธิบายให้ท่านทราบถึงแนวทางปฏิบัติของบริษัท ในส่วนที่เกี่ยวข้องกับข้อมูลส่วนบุคคล และเหตุผลในการเก็บรวบรวม การใช้ การเปิดเผยข้อมูลส่วนบุคคลของท่าน และสิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล
     </div>
     <div>
     ข้อกำหนดและเงื่อนไข
     </div>
     <div>
     <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
       <li>
       	<h5>1.ผู้ควบคุมข้อมูลส่วนบุคคล</h5>
       นโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ใช้บังคับกับข้อมูลส่วนบุคคลที่เก็บรวบรวมโดย บริษัท ซอร์สโค้ด จำกัด (ให้เรียกว่า "บริษัท")
       </li>
       <li>
       <h5>2.ข้อมูลส่วนบุคคล</h5>
       คืออะไร ข้อมูลส่วนบุคคล หมายถึง"ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือ ทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ"
       </li>
       <li>
     	 <h5>3.ข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวม</h5>
     บริษัทจะเก็บรวบรวมข้อมูลส่วนบุคคลอันเกี่ยวกับการใช้บริการในปัจจุบันและที่อาจมีเพิ่มขึ้นในอนาคต ดังต่อไปนี้
         <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
           <li>
         	•	ข้อมูลที่บ่งชี้ตัวตน เช่น ชื่อ นามสกุล วันเกิด เพศ สัญชาติ ภาพถ่าย ภาพและหมายเลขบัตรประจำตัวประชาชน ข้อมูลอุปกรณ์อิเล็กทรอนิกส์ ข้อมูลตำแหน่งที่อยู่
          </li>
          <li>
         	•	ข้อมูลที่ใช้ในการติดต่อ เช่น ที่อยู่ สถานที่ติดต่อ หมายเลขโทรศัพท์ อีเมล
          </li>
          <li>
         	•	ข้อมูลและพฤติกรรมการใช้บริการ หรือผลิตภัณฑ์ที่เกี่ยวข้องกับการบริการ
          </li>
          <li>
         	•	ข้อมูลทางการเงิน เช่น ข้อมูลการชำระเงิน หมายเลขบัตรเครดิต และหมายเลขบัญชีธนาคาร
          </li>
          <li>
         	•	ข้อมูลในการวิเคราะห์การใช้บริการเพื่อการตรวจสอบย้อนหลังในกรณีที่เกิดปัญหาการใช้งานรวมถึงข้อมูลที่บันทึกในระบบรักษาความปลอดภัย เช่น ข้อมูลโทรทัศน์วงจรปิด (กล้องวงจรปิด)
          </li>
          <li>
         	•	ข้อมูลการบันทึกภาพผ่านสื่ออิเล็กทรอนิกส์ และหรือสื่ออื่น เป็นต้น
          </li>
          <li>
         	•	ข้อมูลสาธารณะจากหน่วยงานต่างๆ ตามกฎหมาย
          </li>
          <li>
         	•	ข้อมูลที่จำเป็นสำหรับบริษัทในการปฏิบัติตามกฎหมาย คำขอตามกฎหมายของหน่วยงานบังคับใช้กฎหมายและ/หรือคำสั่งศาล
          </li>
        </ul>
      </li>
       <li>
       <h5>4.แหล่งที่มาของข้อมูลส่วนบุคคล </h5>
       บริษัทอาจได้รับข้อมูลส่วนบุคคลของท่านจากช่องทางดังนี้ <br/>
       บริษัทได้รับข้อมูลส่วนบุคคลจากท่านโดยตรง โดยบริษัทจะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจาก
       ขั้นตอนการให้บริการดังนี้
          <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
          <li>
           	•	ขั้นตอนการสมัครใช้บริการ หรือขั้นตอนการยื่นคำร้องขอใช้สิทธิต่าง ๆ กับบริษัท
            </li>
            <li>
           	•	จากความสมัครใจของท่าน ในการทำแบบสอบถาม (Survey) หรือการได้ตอบทางอีเมล หรือช่องทางการสื่อสารอื่น ๆ ระหว่างบริษัทและท่าน
            </li>
            <li>
           	•	จากการใช้บริการ รวมถึงผลิตภัณฑ์ที่เกี่ยวข้องกับการบริการ
            </li>
            <li>
           	•	เก็บจากข้อมูลการใช้เว็บไซต์ของบริษัทผ่าน Browser's cookies ของท่าน
            </li>
          </ul>
          ข้อมูลจากแหล่งอื่น
          <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
              <li>
           	•	บริษัทได้รับข้อมูลส่วนบุคคลของท่านมาจากบุคคลที่สามซึ่งมีสิทธิเปิดเผยข้อมูลส่วนบุคคลของท่านโดยชอบด้วยกฎหมาย รวมถึงตัวแทนหรือพนักงานหรือลูกจ้างของบริษัทที่บริษัทมีไว้เพื่อช่วยให้บริษัทสามารถคำเนินการสมัครบริการและให้บริการแก่ท่าน โดยได้รับข้อมูลผ่านทางอีเมลได้รับแจ้งทางโทรศัพท์ หรือได้รับเป็นเอกสารหรือในทำนองเดียวกันเช่นว่ามานี้ซึ่งผู้ที่เปิดเผยมีสิทธิให้ข้อมูลส่วนบุคคลได้โดยชอบด้วยกฎหมาย
            </li>
            <li>
           	•	ข้อมูลสาธารณะจากหน่วยงานต่างๆตามกฎหมาย การเรียกร้องจากคำร้องต่างๆเป็นต้น
            </li>
          </ul>
      </li>
      <li>
      <h5>5.วัดถุประสงค์ในการเก็บรวบรวมใช้ หรือเปิดเผยข้อมูลส่วนบุคคล </h5>
   บริษัทเก็บรวบรวมใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ดังต่อไปนี้
   <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
      <li >
        •	เพื่อการให้บริการตามสัญญา การต่ออายุตามสัญญา การเปลี่ยนแปลงหรือยกเลิกสัญญา ซึ่งท่านเป็นคู่สัญญา หรือเพื่อใช้ในการดำเนินการตามคำขอของท่านก่อนเข้าทำสัญญานั้น
        </li>
        <li>
        •	เพื่อการดำเนินการวิเคราะห์ ปรับปรุง และพัฒนาการให้บริการของบริษัทให้มีประสิทธิภาพรวมถึงรายการส่งเสริมการขายหรือผลิตภัณฑ์ของบริษัท
        </li>
        <li>
        •	เพื่ออำนวยความสะดวกในการแจ้งหรือการชำระค่าบริการ
        </li>
        <li>
        •	เพื่อวัตถุประสงค์ในการวิเคราะห์และนำเสนอบริการ นำเสนอหรือให้สิทธิประโยชน์
        </li>
        <li>
        •	เพื่อแจ้งและนำเสนอ สิทธิประโยชน์ ข้อมูล ข่าวสาร รายการส่งสริมการขาย และข้อเสนอต่าง ๆ เกี่ยวกับการสมัคร การซื้อขายสินค้า หรือการใช้บริการต่าง ๆ ของบริษัทรวมถึงนิติบุคคลหรือบุคคลอื่นใด
        </li>
        <li>
        •	เพื่อการสมัคร หรือเปิดใช้บริการที่เกี่ยวข้องกับการสมัคร การซื้อขายสินค้า หรือการใช้บริการต่าง ๆ ของบริษัทรวมถึงนิติบุคคลหรือบุคคลอื่นใด
        </li>
        <li>
        •	เพื่อวัตถุประสงค์ในการวิเคราะห์และวางแผนการตลาด กิจกรรมทางการตลาดของบริษัทและ/หรือร่วมกับนิติบุคคลหรือบุคคลอื่นใด
        </li>
        <li>
        •	เพื่อความปลอดภัยหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพอนามัยของบุคคล
        </li>
        <li>
        •	เพื่อวัตถุประสงค์ของการปฏิบัติตามกฎหมาย และหรือมีเหตุจำเป็นอื่นใดเพื่อประโยชน์อันชอบด้วยกฎหมายของบริษัท
        </li>
        <li>
        •	เพื่อวัตถุประสงค์อื่นตามที่กฎหมายให้อำนาจในการเก็บรวบรวมใช้ หรือเปิดเผย โดยไม่ต้องได้รับความยินยอมจากเจ้าของข้อมูลส่วนบุคคล
        </li>
        <li>
        •	เพื่อการพิสูจน์และยืนยันตัวตนของผู้สมัคร เพื่อสมัครลงทะเบียนและเข้าใช้บริการ
        </li>
        <li>
        •	เพื่อชำระค่าบริการและค่าธรรมเนียมที่เกี่ยวข้องกับสินค้าและบริการ
        </li>
        <li>
        •	เพื่อให้บริการหลังการขาย ให้บริการตามที่ท่านร้องขอ ตอบข้อสงสัย สนับสนุนการใช้งาน ให้ข้อมูลรับเรื่องร้องเรียน ชดเชยค่าเสียหาย และแก้ไขปัญหาและอุปสรรคต่าง ๆ
        </li>
        <li>
        •	เพื่อทำความเข้าใจความต้องการและความพึงพอใจของท่าน
        </li>
        <li>
        •	เพื่อการแจ้งข้อมูล ข่าวสาร จากหน่วยงานกำกับดูแลและภาครัฐ
        </li>
        <li>
        •	เพื่อส่งหนังสือแจ้งค่าบริการ ใบสั่งซื้อสินค้าและบริการ การแจ้งเดือนให้ชำระค่าสินค้าและบริการจัดทำใบเสร็จรับเงินและใบกำกับภาษี ติดตามทวงถามหนี้
        </li>
        <li>
        •	เพื่อการรักษาความปลอดภัยของข้อมูลและเครือข่ายการให้บริการของบริษัท รวมถึงตรวจสอบระบบและกิจกรรมของผู้ใช้บริการ เพื่อติดตามกิจกรรมที่เป็นอันตรายใด ๆ ต่อท่าน ผู้อื่น และบริษัท
        </li>
        <li>
        •	เพื่อการรักษาความปลอดภัยของสถานประกอบการและสาขาของบริษัท เช่น การติดตั้งกล้องวงจรปิด เพื่อความปลอดภัยและป้องกันอาชญากรรม
        </li>
      </ul>
      </li>
      <li>
     <h5>6.การประมวลผลข้อมูลส่วนบุคคล </h5>
     เมื่อได้รับข้อมูลส่วนบุคคลจากแหล่งที่มาของข้อมูลส่วนบุคคลแล้ว บริษัทจะดำเนินการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของท่านตามวัตถุประสงค์ที่ได้แจ้งไว้ ทั้งนี้ บริษัทอาจเปิดเผยข้อมูลส่วนบุคคลข้อมูลการใช้บริการของท่าน ให้แก่บริษัทในเครือของบริษัท ซอร์สโค้ด จำกัด เครือกิจการ เครือธุรกิจหน่วยงานราชการตามกฎหมาย ผู้ให้บริการค้นเทคโนโลยีสารสนเทศ ธนาคารและผู้ให้บริการด้านการชำระเงินและการทำธุรกรรม ผู้ให้บริการสนับสนุนลูกค้า ผู้ให้บริการจัดการด้านการตลาดและการ โฆษณาที่ปรึกษาทางธุรกิจ รวมถึงนิติบุคคลหรือบุคคลอื่นใดที่บริษัทและ/หรือท่านเป็นคู่สัญญาหรือมีนิติสัมพันธ์ตามกฎหมาย นอกจากนี้ บริษัทอาจจำเป็นต้องส่งข้อมูลส่วนบุคคลของท่านไปยังหน่วยงานกำกับดูแลเพื่อตรวจสอบ และอาจใช้ผลการตรวจสอบข้อมูลดังกล่าวเพื่อป้องกันการฉ้อโกง
     <br/>
     บริษัทอาจมีความจำเป็นในการโอนข้อมูลส่วนบุคคลของท่านไปยังบุคคล หน่วยงานต่างประเทศหรือองค์กรระหว่างประเทศ ที่มิได้มีมาตรฐานด้านการคุ้มครองข้อมูลส่วนบุคคลที่เพียงพอ (Appropriate safeguards)
     </li>
     <li>
     	<h5>7.การเก็บรักษาและระยะเวลในการเก็บรักษาข้อมูลส่วนบุคคล  </h5>
     บริษัทมีการเก็บรักษาและระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคลของท่าน ดังนี้
       <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
          <li>
         	•	ลักษณะการเก็บ : จัดเก็บเป็นหนังสือ (Hard copy) และจัดเก็บในระบบอิเล็กทรอนิกส์ (Soft copy) โดยมีมาตรการรักษาความมั่นคงปลอดภัยที่มีประสิทธิภาพ เพื่อป้องกันการสูญหาย เข้าถึงใช้เปลี่ยนแปลง แก้ไข หรือเปิดเผยข้อมูลส่วนบุคคลโดยปราศจากอำนาจหรือโดยมิชอบ
          </li>
          <li>
         	•	ระยะเวลาจัดเก็บ : บริษัทจะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านภายในระยะเวลาเท่าที่จำเป็นตามวัดถุประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคลนั้น หรือภายในระยะเวลาที่มีสัญญาหรือนิติสัมพันธ์ตามกฎหมายระหว่างท่านและบริษัท หรือภายในระยะเวลาการใช้สิทธิเรียกร้องตามกฎหมายของคู่สัญญา
          </li>
          <li>
         	•	เมื่อพ้นระยะเวลาจัดเก็บ หรือบริษัทไม่มีสิทธิหรือไม่สามารถอ้างฐานในการประมวลผลข้อมูลส่วนบุคคลของท่านแล้ว บริษัทจะดำเนินการลบหรือทำลายข้อมูลส่วนบุคคล หรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้ ภายในระยะเวลาอันควร
        </li>
      </ul>
     </li>
     <li>
     	<h5>8.สิทธิของเจ้าของข้อมูลส่วนบุคคล</h5>
     ท่านในฐานะเจ้าของข้อมูลส่วนบุคคลมีสิทธิเกี่ยวกับข้อมูลส่วนบุคคลตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 ดังนี้
     <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
        <li>
     	•	ขอเข้าถึงและขอรับสำนาข้อมูลส่วนบุคคลที่เกี่ยวกับตน ซึ่งอยู่ในความรับผิดชอบของผู้ควบคุมข้อมูลส่วนบุคคล หรือขอให้เปิดเผยถึงการได้มาซึ่งข้อมูลส่วนบุคคลดังกล่าวที่ตนไม่ได้ให้ความยินยอม
      </li>
      <li>
      •	แจ้งให้ผู้ควบคุมข้อมูลส่วนบุคคลต้องดำเนินการให้ข้อมูลส่วนบุคคลนั้นถูกต้องเป็นปัจจุบันสมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด
      </li>
      <li>
      •	ขอรับข้อมูลส่วนบุคคลที่เกี่ยวกับตนจากผู้ควบคุมข้อมูลส่วนบุคคลได้ ในกรณีที่ผู้ควบคุมข้อมูลส่วนบุคคลได้ทำให้ข้อมูลส่วนบุคคลนั้นอยู่ในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปให้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัดโนมัติ และสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ
      </li>
      <li>
      •	คัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลที่เกี่ยวกับตน ที่กฎหมายขออนุญาตให้เก็บได้โดยไม่ต้องไห้รับความยินยอมจากเจ้าของข้อมูล เมื่อใดก็ได้
      </li>
      <li>
      •	ขอให้ผู้ควบคุมข้อมูลส่วนบุคคลดำเนินการลบหรือทำลาย หรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้ ในกรณีตามที่กฎหมายกำหนด
      </li>
      <li>
      •	ขอให้ผู้ควบคุมข้อมูลส่วนบุคคลระงับการใช้ข้อมูลส่วนบุคคลได้ ในกรณีตามที่กฎหมายกำหนด
      </li>
      <li>
     	•	ร้องเรียนในกรณีที่ผู้ควบคุมข้อมูลส่วนบุคคลหรือผู้ประมวลผลข้อมูลส่วนบุคคล รวมทั้งตัวแทนหรือลูกจ้างหรือผู้รับจ้างของผู้ควบคุมข้อมูลส่วนบุคคลหรือผู้ประมวลผลข้อมูลส่วนบุคคล ฝ่าฝืนหรือ ไม่ปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
      </li>
      <li>
     	•	สิทธิในการถอนความยินยอม
          <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
             <li>
               ก.) เมื่อท่านให้ความยินยอมกับบริษัทเพื่อวัตถุประสงค์อย่างหนึ่งอย่างใดในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลดังกล่าวข้างต้นแล้ว ท่านมีสิทธิถอนความยินยอมเมื่อใดก็ได้ เว้นแต่เป็นกรณีที่มี ข้อจำกัดสิทธิตามกฎหมาย หรือเกี่ยวข้องกับสัญญาที่ให้ประโยชน์แก่ท่าน
               </li>
               <li>
               ข) ท่านมีสิทธิในการถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมกับบริษัทได้ตลอดเวลาที่ข้อมูลส่วนบุคคลของท่านอยู่กับบริษัทและบริษัทอาจขอทราบถึงเหตุผลแห่งการนั้น
               </li>
               <li>
               ค.) ในการดำเนินการใช้สิทธิขอถอนความยินยอม ท่านจะต้องติดต่อและขอใช้สิทธิด้วยตัวท่านเองตามช่องทางที่บริษัทกำหนดไว้
               </li>
             </ul>
           </li>
         </ul>
     </li>
     <li>
      <h5>9.ผลการเพิกถอนความยินยอม</h5>
      <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
         <li>
         	•	การเพิกถอนความยินยอมของเจ้าของข้อมูลส่วนบุคคล จะไม่ส่งผลกระทบต่อการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคล ที่เข้าของข้อมูลส่วนบุคคลได้ให้ความยินยอมไปแล้วก่อนหน้านั้น
          </li>
          <li>
         	•	ในกรณีที่ท่านประสงค์ที่จะเพิกถอนความยินยอม ให้บริษัทเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
          </li>
          <li>
         	•	หากการถอนความยินยอมของท่านทำให้บริษัท ไม่สามารถส่งมอบผลิตภัณฑ์หรือให้บริการบางอย่างให้แก่ท่านได้ บริษัทจะแจ้งให้ท่านทราบถึงผลกระทบจากการถอนความยินยอม ซึ่งอาจมีผลให้บริษัทไม่สามารถปฏิบัติตามสัญญาหรือการให้บริการกับท่านได้
          </li>
        </ul>
        ท่านสามารถติดต่อเจ้าหน้าที่ของบริษัทเพื่อยื่นคำร้องขอใช้สิทธิข้างต้นตามรายละเอียดที่ปรากฏในข้อ 14.หรือตามช่องทางที่บริษัทกำหนด บริษัทมีสิทธิในการปฏิเสธคำร้องขอที่เป็นการใช้สิทธิโดยไม่สุจริต คำร้องขอที่ไม่สมเหตุสมผล คำร้องขอที่กฎหมายไม่ได้บัญญัติไว้และ หรือคำร้องขอที่ไม่สามารถปฏิบัติไว้จริงนอกจากนี้ บริษัทมีสิทธิในการปฏิเสธคำร้องขอของท่านตามหลักเกณฑ์ที่กฎหมายกำหนด
      </li>
      <li>
     	<h5>10.ในกรณีที่ท่านปฏิเสธไม่ให้ใช้ข้อมูลส่วนบุคคล</h5>
     บริษัทมีความจำเป็นต้องรวบรวมข้อมูลส่วนบุคคลตามกฎหมายหรือเพื่อการเข้าทำสัญญาระหว่างท่านกับบริษัท หากท่านเลือกที่จะไม่ให้ข้อมูลส่วนบุคคล บริษัทอาจไม่สามารถให้บริการแก่ท่านได้
     <br/>
     นอกเหนือจากกรณีที่บริษัทใช้ข้อมูลส่วนบุคคลเพื่อการปฏิบัติตามสัญญาและการปฏิบัติตามกฎหมาย ในกรณีที่ท่านไม่ยินยอมให้ใช้ข้อมูลส่วนบุคคล ท่านยังคงสามารถใช้บริการของบริษัทได้ โดยท่านอาจได้รับความสะดวกจากการใช้บริการน้อยลง เนื่องจากบริษัทไม่ได้รับความยินยอมให้ใช้ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์สำหรับการให้บริการอย่างเต็มประสิทธิภาพ
     </li>
     <li>
     	<h5>11.กิจกรรมทางการตลาดและการส่งเสริมการตลาด</h5>
       ในระหว่างการใช้บริการ บริษัทจะส่งข้อมูลข่าวสารเกี่ยวกับกิจกรรมทางการตลาดและการส่งเสริมการตลาดผลิตภัณฑ์และบริการของบริษัท รวมถึงบริษัทในครือบริษัท ซอร์สโค้ด จำกัด ผู้โฆษณา และพันธมิตรทางธุรกิจ ที่ท่านอาจมีความสนใจ โดยท่านสามารถคำเนินการยกเลิกความยินยอมในการรับแจ้งข้อมูลข่าวสารได้ ตามรายละเอียดที่ปรากฏในข้อ 15. หรือตามช่องทางที่บริษัทกำหนด
     </li>
     <li>
     	<h5>12.นโยบายคุ้มครองข้อมูลส่วนบุคคลของเว็บไซต์อื่น</h5>
      นโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ใช้เฉพาะสำหรับการให้บริการของบริษัทและการใช้งานเว็บไซต์ของบริษัทเท่านั้น หากท่านได้เชื่อมต่อไปยังเว็บไซต์อื่น แม้ผ่านช่องทางในเว็บไซต์ของบริษัทก็ตาม ท่านจะต้องศึกษาและปฏิบัติตามนโยบายคุ้มครองข้อมูลส่วนบุคคลที่ปรากฎในว็บไซต์นั้น ๆ แยกต่างหากจากของบริษัท
     </li>
     <li>
       <h5>13.การเปลี่ยนแปลงนโยบายคุ้มครองข้อมูลส่วนบุคคล</h5>
       บริษัทจะทำการพิจารณาทบทวนนโยบายคุ้มครองข้อมูลส่วนบุคคลเป็นประจำเพื่อให้สอดคล้องกับแนวปฏิบัติ และกฎหมาย ข้อบังคับที่เกี่ยวข้อง ทั้งนี้ บริษัทขอสงวนสิทธิในการเปลี่ยนแปลงนโยบายดังกล่าวในเว็บไซต์โดยไม่ต้องแจ้งให้ท่านทราบล่วงหน้า
       บริษัทในเครือบริษัท ซอร์สโค้ด จำกัด ได้แก่ บริษัท สเปเชียล สแควร์ จำกัด
       <br/>
      </li>
       <li>
     	<h5>14.ข้อตกลงการใช้งานระบบ</h5>
      <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
         <li>
       	•	โปรแกรม Alpha Box ปฏิบัติตามพระราชบัญญัติคอมพิวเตอร์ พ.ศ. 2550 โดยเก็บ log files ของข้อมูลการจราจรทางคอมพิวเตอร์ เป็นเวลา 90 วัน นับตั้งแต่วันที่ข้อมูลนั้นเข้าสู่ระบบคอมพิวเตอร์ ผู้ใช้บริการจะต้องไม่กระทำการใด ๆ อันเป็นเหตุทำให้ผู้อื่นเกิดความเสียหายและ/หรือจะต้องไม่กระทำการใด ๆ อันเป็นความผิดต่อพระราชบัญญัติว่าด้วยการกระทำผิดเกี่ยวกับคอมพิวเตอร์ พ.ศ.2550 และ/หรือกฎหมายอื่นใดที่กำหนดความผิดเกี่ยวกับการใช้งานคอมพิวเตอร์และการใช้งานเครือข่ายอินเทอร์เน็ต หากผู้ใช้บริการฝ่าฝืน ผู้ใช้บริการจะต้องรับผิดในความเสียหายที่เกิดขึ้นจากกรณีดังกล่าวแต่เพียงผู้เดียว
        </li>
        <li>
        •	บริการ hi-speed Internet ที่ให้บริการภายในอาคารนี้ เป็นระบบเครือข่ายที่ต่อเชื่อมอินเตอร์เน็ตความเร็วสูงแบบแชร์สปีดจากผู้ให้บริการอินเตอร์เน็ต (ISP) ดังนั้น ความเร็วในการรับ-ส่งข้อมูล จึงขึ้นอยู่กับความเร็วตั้งต้นจากผู้ให้บริการอินเตอร์เน็ต (ISP) และจำนวนผู้ใช้บริการอินเทอร์เน็ตที่ใช้งานอินเทอร์เน็ตอยู่ในขณะนั้น
        </li>
        <li>
        •	การดาวน์โหลดไฟล์ขนาดใหญ่รวมทั้งการดาวน์โหลดจากเว็บไซต์ต่างประเทศในช่วงเวลาที่มีจำนวนผู้ใช้บริการหนาแน่น (18.00-24.00น.) อาจทำให้ความเร็วของอินเตอร์เน็ตลดลงมาก
        </li>
        <li>
        •	ความเร็วในการเชื่อมต่อ คือ ความเร็วของคอมพิวเตอร์ที่เชื่อมต่อกับโครงข่าย hi-speed Internet (ไม่ใช่ความเร็วในการดาวน์โหลดข้อมูล) ความเร็วในการดาวน์โหลดที่แท้จริงอาจจะต่ำกว่าความเร็วสูงสุดในการเชื่อมต่อตามประเภทที่เลือกใช้บริการฯ โดยเฉพาะเว็บไซต์ที่ตั้งอยู่ต่างประเทศซึ่งขึ้นอยู่กับหลายปัจจัย เช่น ความเข้มของสัญญาณที่เชื่อมต่อ (กรณีเป็นเครือข่ายแบบไร้สาย Wireless) สภาพเครื่องคอมพิวเตอร์ ความเร็วในการเชื่อมต่อของอินเตอร์เน็ต และการติดขัดของข้อมูลอินเตอร์เน็ต รวมถึงอุปกรณ์เซิร์ฟเวอร์ และ Router ของเว็บไซต์ที่ผู้ใช้บริการเข้าเยี่ยมชม และปัจจัยอื่น ๆ อีกหลายประการ
        </li>
        <li>
        •	Alpha Box เป็นเพียง Software ที่ใช้ในการบริหารจัดการระบบอินเตอร์เน็ตเท่านั้น ไม่มีส่วนรับผิดชอบในข้อผิดพลาดของระบบและเครือข่ายอินเตอร์เน็ตไม่ว่ากรณีใด ๆ และขอสงวนสิทธิ์ในการปิดปรับปรุงระบบเมื่อมีข้อผิดพลาดเกิดขึ้นไม่ว่ากรณีใด ๆ
        </li>
        <li>
        •	Username และ Password ที่ถูกต้องจะสามารถใช้งาน ณ สถานที่เดียวกันที่ได้รับ Username และ Password นั้นมาเท่านั้น Alpha Box ไม่รับผิดชอบต่อ Username และ Password ที่ได้รับมาจากสถานที่อื่นแล้วไม่สามารถใช้งานได้
        </li>
        <li>
        •	Alpha Box ขอสงวนสิทธิ์ระงับการให้บริการชั่วคราว โดยไม่ต้องแจ้งให้ทราบล่วงหน้า หากตรวจพบว่า เครื่องคอมพิวเตอร์ที่เชื่อมต่ออยู่กับระบบนั้นเป็นสาเหตุให้ระบบโดยรวมเกิดปัญหา เช่น ไวรัส, ใช้โปรแกรมประเภท P2P หรือ Torrent ในการดาวน์โหลด
        </li>
        <li>
        •	การดาวน์โหลดไฟล์ที่มีลิขสิทธิ์ต่าง ๆ โดยไม่ได้รับอนุญาต ถือเป็นการละเมิดลิขสิทธิ์ซึ่งผู้กระทำการมีความผิดทางกฎหมาย ทาง Alpha Box ไม่มีส่วนรับผิดชอบใด ๆ ทั้งสิ้น
        </li>
        </ul>
      </li>
      <li>
     	<h5>15.ช่องทางติดต่อ</h5>
       เจ้าของข้อมูลส่วนบุคคลสามารถติดต่อบริษัทตามช่องทาง ดังนี้
       <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
          <li>
       	•	ฝ่ายบริการลูกค้าสัมพันธ์ บริษัท ซอร์สโค้ด จำกัด เลขที่ 75/62, 75/63, 75/63, 75/64., 75/65 อาคารบีเคซีเอส กรุ๊ป ซอยรามคำแหง 21 ถนนรามคำแหง แขวงหัวหมาก เขตบางกะปิ กรุงเทพมหานคร10240
        </li>
        <li>
       	•	เบอร์โทรศัพท์ : 02-0261919
        </li>
        <li>
       	•	อีเมล : support@smartzoneonline.com
        </li>
        <li>
       	•	เว็บไซต์ : www.smartzoneonline.com
        </li>
        </ul>
      </li>
      </ul>
      </div>
      <div>
      อนึ่ง ก่อนให้ความยินยอมข้าพเจ้าได้อ่านและเข้าใจข้อกำหนดและเงื่อนไขในการเปิดเผยข้อมูลส่วนบุคคลซึ่งระบุไว้ด้านบนของความยินยอมนี้อย่างชัดเจนแล้ว
     </div>

     </>:
     <>
      <div>
      This Privacy Policy has been created to provide you the practices of this company regarding the Personal Data and the causes for the collection, use or disclosure of your Personal Data, and your rights as the Data Subject.
      </div>
      <div>
      Terms and conditions
      </div>

      <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
         <li>
          <h5>1. Data Controller</h5>
          This Privacy Policy will be enforced on the Personal Data collected by SourceCode Co., Ltd. (“the company”).
          </li>
          <li>
          <h5>2. What is Personal Data?</h5>
          Personal Data means “any information relating to a Person, which enables the identification of such Person, whether directly or indirectly, but not including the information of the deceased Persons in particular”.
          </li>
          <li>
          <h5>3. Personal Data that the company collects</h5>
          The company will collect Personal Data regarding the current use of the services, and may expand to other additional data in the future, as follows:
          <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
             <li>
          	•	Personal Data such as name, surname, age, date of birth, nationality, photo and numbers of identification card, data collected from electronic devices, location data.
            </li>
            <li>
          	•	Contact information such as address, contact address, telephone number, e-mail address.
            </li>
            <li>
          	•	Data and behavior information on the use of the services or service-related products.
            </li>
            <li>
          	•	Financial information such as payment information, credit card numbers and bank account numbers.
            </li>
            <li>
          	•	Data used to analyze the use of the services, for the traceability purpose when the clients encountered the problem while using the services, which including the data collected by the security system such as CCTV footage, the recordings of electronic medias and/or other medias.
            </li>
            <li>
          	•	Public information from various agencies, in accordance with the law.
            </li>
            <li>
          	•	The data that the company is required to collect to be able to comply with the law, legal requests by law enforcement agencies, and/or court orders.
            </li>
          </ul>
            </li>
            <li>
            <h5>4. The sources of Personal Data</h5>
            The company may retrieve your Personal Data from the following channels:
            <br/>
            The company receives your Personal Data directly from you. In which the company will collect your Personal Data throughout the service procedures as follows:
            <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
               <li>
            	•	Service sign-up procedures or procedures to process the requests to exercise the rights with the company.
              </li>
              <li>
            	•	Data collected voluntarily from your participation through survey taking, correspondence between the company and you via email or other communication channels.
              </li>
              <li>
            	•	Data collected from the use of services and service-related products.
              </li>
              <li>
            	•	Information about the use of the company’s website which is collected through your browser’s cookies.
              </li>
            </ul>
            Data collected from the other sources:
            <ul>
               <li>
            	•	The company receives your Personal Data through third parties which have the right to lawfully disclose your Personal Data. The company also receives data through emails, telephone calls, or documents, or other similar means from the representatives or the staffs or the workers of other companies that we utilize their services to help providing the service registration and service offering to you, and that they have the right to lawfully disclose your Personal Data.
              </li>
              <li>
              •	Public information provided by law from various agencies. The request to exercise the rights, etc.
              </li>
            </ul>
              </li>
              <li>
              <h5>5. The purposes for data collection or Personal Data disclosure</h5>
              The company collects, uses and discloses your Personal Data for the following purposes:
              <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
                 <li>
              	•	To provide the services in accordance with the contracts, the renewal of contracts, the modification or termination of contracts, in which you are the party of such contract. Or to process your requests before you enter into the contract.
                </li>
                <li>
              	•	To analyze, adjust, and improve the company’s service performance, and including the promotional campaigns or products.
                </li>
                <li>
              	•	To provide convenient payment notification or payment methods.
                </li>
                <li>
              	•	For purpose of data analysis to provide services, offers or benefits.
                </li>
                <li>
              	•	To inform and offer benefits, information, news, promotional campaigns, and offers about the registration, sales, and services provided by the company, and including other juristic persons or persons.
                </li>
                <li>
              	•	For registration or procedures relating to the registration activation, sales or services provided by the company, and including other juristic persons or persons.
                </li>
                <li>
              	•	For analytical purposes on marketing, marketing activities by the company and/or with other juristic persons or persons.
                </li>
                <li>
              	•	For safety or alleviation of dangers towards life, body, or well-being of persons.
                </li>
                <li>
              	•	For the purpose of the legal compliance and/or other necessities for the company’s lawful profits.
                </li>
                <li>
              	•	For other purposes in which the laws authorize the Personal Data collection, usage, and disclosure without consent from Data Subjects.
                </li>
                <li>
              	•	To prove and authenticate the identities for service registration and sign-in.
                </li>
                <li>
              	•	To pay the service charges and fees relating to products and services.
                </li>
                <li>
              	•	To provide after-sales services, provide the services as requested by you, answer the inquiries, provide customer supports, provide information, handle the complaints, compensate the damages, and resolve the problems and obstacles.
                </li>
                <li>
              	•	To recognize your demands and satisfactions.
                </li>
                <li>
              	•	To inform the information and news from regulators and state agencies.
                </li>
                <li>
              	•	To send the service bills, product and service purchase orders, payment reminders for services and products bills. And to issue receipts and tax receipts, and collect the debts.
                </li>
                <li>
              	•	To provide security safeguards for the company’s service data and network, including the inspection of the system and user activities, to monitor any malicious activity which may affect you, others, and the company.
                </li>
                <li>
              	•	To provide security safeguards for the company’s establishments and branches, such as installing CCTV camera to heighten safety and crime prevention.
                </li>
              </ul>
                </li>
                <li>
                <h5>6. Personal Data processing</h5>
                After the company receives Personal Data from the sources, the company will collect, use, or disclose your Personal Data for the purposes as stated earlier. The company may disclose your Personal Data and information about your use of services to the affiliated companies of SourceCode Co., Ltd., affiliated business and networks, authorized government agencies, the information and communications technology service providers, banks and financial services and payments providers, the customer support services, the marketing and advertisement providers, the business consultants, and the juristic persons or other persons in which the company or you are parties to, or have legal relations with as prescribed by the law. Moreover, the company may need to submit your Personal Data to the regulators for inspection and may use the result of such inspection for fraud prevention.
                <br/>
                The company may need to transfer your Personal Data to foreign persons, agencies or international organizations which may not have appropriate safeguards for the protection of Personal Data.
                </li>
                <li>
                <h5>7. Storage of data and data retention period</h5>
                The company stores and retains your Personal Data as follows:
                <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
                   <li>
                	•	Storage of data methods: data is stored as hard copy and soft copy under the effective and steady security measures to prevent the data loss, unauthorized or unlawful access, usage, changes, modification and disclosure of Personal Data.
                  </li>
                  <li>
                	•	Data retention period: The company will store your Personal Data for as long as necessary in connection with the purposes for that data. Or for as long as necessary during the period that you have the contract or legal relation with the company. Or for as long as the period to exercise the rights still exists between parties.
                  </li>
                  <li>
                	•	Once the data retention period has passed or the company no longer has the right or does not have the basis to process your Personal Data, the company will erase, destroy or anonymize your Personal Data within appropriate period.
                  </li>

                </ul>
                </li>
                  <li>
                <h5>8. Data Subject Rights</h5>
                You, as the Data Subject, have the rights about Personal Data which you may exercise in accordance to The Personal Data Protection Act B.E. 2562 (2019) as follows:
                <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
                   <li>
                	•	Access and request a copy of your Personal Data that is under the Data Controller’s responsibility or request to reveal as to how your Personal Data is obtained without your consent.
                  </li>
                  <li>
                	•	Request the Data Collectors to rectify your Personal Data to be updated, complete and not misleading.
                  </li>
                  <li>
                	•	Obtain your Personal Data from the Data Controller, in the case that the Data Controller organizes such Personal Data in automatic machine-readable or usable format and can be processed or disclosed by automatic means.
                  </li>
                  <li>
                	•	Object to collection, use or disclosure of your Personal Data that can be lawfully collected without consent from Data Subjects at any time.
                  </li>
                  <li>
                	•	Request that your Personal Data be erased, destroyed or anonymized, in accordance with the law.
                  </li>
                  <li>
                	•	Request the Data Collectors to suspend the use of Personal Data, in accordance with the law.
                  </li>
                  <li>
                	•	Lodge the complaint about the breach or non-compliance of the law by the Data Controllers, Data Processors, and including the representatives or the staffs or the contractors of the Data Controllers or Data Processors.
                  </li>
                  <li>
                	•	The right to withdraw consent.
                  </li>
                  <li>
                	•	When you have given consent to the company to collect, use or disclose Personal Data for one of the purposes as stated above. You have the right to withdraw your consent at any given time. Unless it is restricted by laws or you are still under beneficial contract.
                  </li>
                  <li>
                	•	You have the right to withdraw your consent to process the Personal Data at any given time as long as the data is with the company and the company may inquire about the reasons for consent withdrawal.
                  </li>
                  <li>
                	•	To start the procedures to exercise the right to withdraw consent, you have to contact and request to exercise such right by yourself through the contact channels provided by the company.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <h5>9. Consequences of consent withdrawal</h5>
                  <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
                     <li>
                  	•	The withdrawal of consent by Data Subjects will not affect the collection, use, and disclosure of Personal Data which the Data Subjects had previously consented before.
                    </li>
                    <li>
                  	•	In case you express your intention to withdraw your consent for the collection, use, and disclosure of Personal Data. If the withdrawal of consent will render the company incapable of delivering some products or services for you. The company will inform you of the consequences arising from such withdrawal which may result in the default of contract or that the company cannot continue to provide services for you.
                  You can contact the staffs of the company to file for the request to exercise the right as mentioned above by following the details provided within section no. 14 or submit your request to the designated channel. The company reserves the right to deny the requests which are found to be made with bad faith, the unreasonable requests, the requests that are out of the scope of the law, and/or the unenforceable requests. The company also has the right to deny your request, in accordance with the rules set by the law.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <h5>10. In case of the objection against Personal Data collection</h5>
                  The company is required to gather Personal Data either by law or in order to make a contract between you and the company. If you choose to object the use of Personal Data, the company may subsequently be unable to serve you further.
                  <br/>
                  Other than the company’s use of Personal Data to abide by the contracts and the law. In case you do not consent to the use of Personal Data, you are still able to use the company’s services but with lesser convenience. Because the company does not have the consent to use Personal Data for the purposes of providing service to the full extent.
                  </li>
                  <li>
                  <h5>11. Marketing activities and campaigns</h5>
                  During the use of the services, the company will send information regarding marketing activities and campaigns, products and services of the company, including those from affiliated companies of SourceCode Co., Ltd., advertisers and business partnerships, which you maybe interested in. You can withdraw your consent to receive information by submitting the request as detailed in section 14, or submitting the request through the designated channels.
                  </li>
                  <li>
                  <h5>12. Privacy Policy from other websites</h5>
                  This Privacy Policy only applies to the services of the company and the use of the company’s website. Even if you have connected to other websites though the company’s website, you will have to be aware and comply with the different Privacy Policy that appears on that website separately.
                  </li>
                  <li>
                  <h5>13. Changes to this Privacy Policy</h5>
                  The company will review this Privacy Policy regularly to make sure it is coincided with the related practices, regulations, and rules. The company reserves the right to change the website’s Privacy Policy without prior notice.
                  Affilated companies of SourceCode Co., Ltd. are Special Square Co., Ltd.
                  </li>
                  <li>
                  <h5>14. Terms of Use</h5>
                  <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
                     <li>
                  	•	Alpha Box software is in abidance with the 2007 Computer Crime Act by keeping log files of computer network traffic for 90 days counting from the day the traffic data entered the system. Alpha Box Users must not do any actions that would cause damage or illegal to the 2007 Computer Crime Act or other laws concerning illegal usage of computer and the internet. Alpha Box Users who violate these laws are hold solely responsible for the damages occurred by violation.
                    </li>
                    <li>
                  	•	Hi-speed internet service in this building or area is a computer network that connects to a shared hi-speed internet connection from an internet service provider (ISP). Therefore, the speed of downloading and uploading data is subject to the speed from the ISP and the number of internet users who are using the service at that time.
                    </li>
                    <li>
                    •	Downloading of large files as well as downloading from international sites during peak usage times (6pm to midnight) may cause a large drop in internet speed.
                    </li>
                    <li>
                    •	Internet connection speed is that speed which the computer connects to the hi-speed internet network (Not the speed of downloading data). The actual download speed might be lower than the maximum internet connection speed, especially for international websites, and depends upon many other factors, for example; wireless signal density (if connected by wifi), computer condition, internet connection speed, internet latency, as well as the server and router equipment of the website visited, etc.
                    </li>
                    <li>
                    •	Alpha Box software is software for internet system management only. Alpha Box shall not be liable for any internet errors and reserves the right to shutdown the system for maintenance in all conditions.
                    </li>
                    <li>
                    •	Correct Usernames and Passwords are only usable at the location they were received. Alpha Box shall not be liable for unusable Username and Passwords that are received from other locations.
                    </li>
                    <li>
                  	•	Alpha Box reserves the right to to temporarily disable our service without notice if we've detected that your computer has caused problems to the overall system, for example viruses, P2P or Torrent programs for downloading.
                    </li>
                    <li>
                  	•	Downloading licensed material from the internet without the owner's persmission is a violation of rights and is considered illegal. Alpha Box takes no responsibility for the user's illegal action.
                        </li>
                      </ul>
                    </li>
                    <li>
                    <h5>15. Contact information</h5>
                    Data Subjects can contact the company as follows:
                    <ul style={{listStyleType: 'none' ,paddingLeft: 8}}>
                       <li>
                    	•	Customer service, SourceCode Co., Ltd.
                    75/62, 75/63, 75/63, 75/64, 75/65 BKCS Group Bldg., Soi Ramkhamhaeng 21, Ramkhamhaeng Rd., Huamak, Bangkapi, Bangkok 10240
                    </li>
                    <li>
                    	•	Telephone numbers: 02-0261919
                      </li>
                      <li>
                    	•	Email: support@smartzoneonline.com
                      </li>
                      <li>
                    	•	Website: www.smartzoneonline.com
                        </li>
                      </ul>
                    I hereby acknowledge that, prior to giving consent, I have read and understand the terms and conditions regarding Personal Data disclosure which has been explicitly stated above.
              </li>
          </ul>



     </>
   }



  </div>
}

export default PopupAgreement;
